import React, { PropTypes, Component } from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import { Grid, Row, Col } from 'react-bootstrap'
import { messages as links } from '../app/App'
import ContactForm from './ContactForm'
import './ContactSection.scss'

const messages = defineMessages({
  header: {
    id: 'contact.header',
    defaultMessage: 'Chcete vědět víc?',
  },
  subHeader: {
    id: 'contact.subHeader',
    defaultMessage: 'Skvěle! Stačí když nám napíšete nebo zavoláte a my vám vytvoříme nezávaznou nabídku!',
  },
  nameLabel: {
    id: 'contact.info.name.label',
    defaultMessage: 'Jméno',
  },
  nameText: {
    id: 'contact.info.name.text',
    defaultMessage: 'Adam Borovský',
  },
  emailLabel: {
    id: 'contact.info.email.label',
    defaultMessage: 'Email',
  },
  emailText: {
    id: 'contact.info.email.text',
    defaultMessage: 'adam@stadyum.cz',
  },
  phoneLabel: {
    id: 'contact.info.phone.label',
    defaultMessage: 'Telefon',
  },
  phoneText: {
    id: 'contact.info.phone.text',
    defaultMessage: '+420 728 968 706',
  },
  address: {
    id: 'contact.info.address',
    defaultMessage: 'Kaprova 42/14, Staré Město, 110 00 Praha 1, Česká republika',
  },
  companyID: {
    id: 'contact.info.company.id',
    defaultMessage: 'IČ: 03239292',
  },
  companyName: {
    id: 'contact.info.company.name',
    defaultMessage: 'Yum Group s.r.o.',
  },
  bankAccount: {
    id: 'contact.info.bank.account',
    defaultMessage: 'č. ú.: 2900631296/2010',
  },
  registry: {
    id: 'contact.info.registry',
    defaultMessage: 'Společnost zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 229150',
  },
})

const ContactSection = ({ intl, replaceHeader }) => (
  <section className="contact-section">
    <a name={intl.formatMessage(links.linkContactUrl)} id={intl.formatMessage(links.linkContactUrl)}></a>
    {!replaceHeader && <h2>{intl.formatMessage(messages.header)}</h2>}
    {!!replaceHeader && <h2>{replaceHeader}</h2>}
    {!!replaceHeader && <p className="subheader">&nbsp;</p>}
    {!replaceHeader && <p className="subheader">{intl.formatMessage(messages.subHeader)}</p>}
    <Grid>
      <Row>
        <Col sm={6}>
          <ContactForm />
        </Col>
        <Col sm={6}>
          <p className="label">{intl.formatMessage(messages.nameLabel)}</p>
          <p className="email">{intl.formatMessage(messages.nameText)}</p>
          <p className="label">{intl.formatMessage(messages.emailLabel)}</p>
          <p className="email">{intl.formatMessage(messages.emailText)}</p>
          <p className="label">{intl.formatMessage(messages.phoneLabel)}</p>
          <p className="phone">{intl.formatMessage(messages.phoneText)}</p>
          <p className="stadyum">
            <strong>{intl.formatMessage(messages.companyName)}</strong><br />
            {intl.formatMessage(messages.address)}<br />
            {intl.formatMessage(messages.companyID)}<br />
            {intl.formatMessage(messages.bankAccount)}
          </p>
          <p className="registry">
            {intl.formatMessage(messages.registry)}
          </p>
        </Col>
      </Row>
    </Grid>

  </section>
)

ContactSection.defaultProps = {
  replaceHeader: '',
}
ContactSection.propTypes = {
  intl: React.PropTypes.object.isRequired,
  replaceHeader: React.PropTypes.string,
}

export default injectIntl(ContactSection)



// WEBPACK FOOTER //
// ./src/browser/ContactSection/ContactSection.js